<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <site-modal ID="ruleModal" modalSize="medium" @Closed="closedRuleModal">
      <template #header>
        <h6>قرارداد اخلاقی شرکت در گروه درمانی</h6>
        <!-- <h6>
          {{
            workshopData.workshopGroupTherapyType == 1
              ? 'قرارداد اخلاقی شرکت در گروه درمانی'
              : 'قرارداد اخلاقی شرکت در کارگاه روانشناسی'
          }}
        </h6> -->
      </template>
      <template #body>
        <div class="row">
          <div class="col-12">
            <div v-if="workshopData.workshopGroupTherapyType == 1">
              <p class="text-justified">
                این قرارداد جهت حفظ اصول اخلاقی و حرفه‌ای در جلسات گروه درمانی
                تدوین شده است و لازم است که همه اعضای گروه با پذیرش و رعایت مفاد
                زیر، در جهت ایجاد محیطی امن و حمایتگر تلاش کنند. با امضای این
                قرارداد، شما متعهد می‌شوید که موارد زیر را رعایت نمایید:
              </p>
              <p class="text-justified">
                <strong>1. حفظ محرمانگی</strong>
                <br />
                من متعهد می‌شوم که تمام اطلاعات و مسائل مطرح‌شده توسط اعضای گروه
                را محرمانه نگه دارم و هیچ‌یک از جزئیات را خارج از جلسات با افراد
                دیگر به اشتراک نگذارم.
              </p>

              <p class="text-justified">
                <strong>2. احترام به استقلال افراد</strong>
                <br />
                من متعهد می‌شوم که به حق دیگران برای تصمیم‌گیری در مورد میزان و
                نوع اطلاعاتی که مایلند به اشتراک بگذارند، احترام بگذارم و از
                ایجاد فشار بر آن‌ها برای صحبت درباره مسائل شخصی خودداری کنم.
              </p>
              <p class="text-justified">
                <strong> 3. صداقت و شفافیت </strong>
                <br />
                من متعهد می‌شوم که با صداقت و شفافیت در جلسات گروه درمانی شرکت
                کنم و احساسات و تجربیات خود را به‌درستی و بدون تحریف بیان کنم.
              </p>
              <p class="text-justified">
                <strong> 4. پرهیز از آسیب‌رسانی </strong>
                <br />
                من متعهد می‌شوم که از هرگونه رفتار یا گفتاری که ممکن است باعث
                ناراحتی یا آسیب روانی دیگران شود، خودداری کنم و به ایجاد محیطی
                امن و محترمانه برای همه اعضای گروه کمک کنم.
              </p>
              <p class="text-justified">
                <strong> 5. پرهیز از روابط خارج از جلسه </strong>
                <br />
                من متعهد می‌شوم که از برقراری روابط دوستانه یا حرفه‌ای خارج از
                جلسات با سایر اعضای گروه خودداری کنم تا به بی‌طرفی و روند درمان
                آسیب وارد نشود.
              </p>
              <p class="text-justified">
                <strong> 6. پایبندی به استانداردهای حرفه‌ای </strong>
                <br />
                من متعهد می‌شوم که به استانداردهای حرفه‌ای و اخلاقی گروه درمانی
                پایبند باشم و در مسیر رشد و یادگیری مداوم خود تلاش کنم.
              </p>
              <p class="text-justified">
                <strong> 7. احترام و عدم قضاوت </strong>
                <br />
                من متعهد می‌شوم که در تمامی گفت‌وگوها و تعاملات، احترام به
                دیگران را رعایت کرده و از قضاوت‌های شخصی پرهیز کنم، و به تنوع
                دیدگاه‌ها و تجربیات افراد احترام بگذارم.
              </p>
              <p class="text-justified">
                <strong> 8. تشویق به رشد شخصی و مسئولیت‌پذیری </strong>
                <br />
                من متعهد می‌شوم که برای رشد شخصی خود در این فرآیند تلاش کرده و
                مسئولیت تغییرات مثبت در زندگی خود را بپذیرم.
              </p>
            </div>

            <!-- <div v-if="workshopData.workshopGroupTherapyType == 2">
              <p class="text-justified">
                این قرارداد بر اساس اصول انجمن روان‌شناسی آمریکا (APA) برای حفظ
                اصول اخلاقی و حرفه‌ای در کارگاه‌های روانشناسی تنظیم شده است. با
                امضای این قرارداد، شما به عنوان شرکت‌کننده متعهد می‌شوید که
                موارد زیر را در طول کارگاه رعایت کنید:
              </p>
              <p class="text-justified">
                <strong>1. حفظ محرمانگی</strong>
                <br />
                من متعهد می‌شوم که تمامی اطلاعات و مسائل شخصی مطرح‌شده توسط سایر
                شرکت‌کنندگان را محرمانه نگه دارم و هیچ‌یک از جزئیات را خارج از
                کارگاه با دیگران به اشتراک نگذارم، مگر با رضایت آن فرد.
              </p>

              <p class="text-justified">
                <strong> 2. احترام به استقلال و حق انتخاب افراد </strong>
                <br />
                من متعهد می‌شوم که به حق دیگران برای تصمیم‌گیری در مورد میزان و
                نوع اطلاعاتی که مایلند به اشتراک بگذارند، احترام بگذارم و از
                اعمال فشار برای صحبت درباره مسائل شخصی آن‌ها خودداری کنم.
              </p>
              <p class="text-justified">
                <strong> 3. صداقت و شفافیت </strong>
                <br />
                من متعهد می‌شوم که به‌طور صادقانه و شفاف در کارگاه شرکت کنم و
                تجربیات و نظرات خود را بدون تحریف بیان نمایم. همچنین، از
                برگزارکنندگان انتظار دارم که اطلاعات مربوط به اهداف و محتوای
                کارگاه را به شکلی شفاف ارائه کنند.
              </p>
              <p class="text-justified">
                <strong> 4. پرهیز از آسیب‌رسانی </strong>
                <br />
                من متعهد می‌شوم که از هرگونه رفتار یا گفتاری که ممکن است به سایر
                شرکت‌کنندگان آسیب روحی یا روانی وارد کند، خودداری کنم و به ایجاد
                محیطی امن و حمایتگر برای همه کمک کنم.
              </p>
              <p class="text-justified">
                <strong> 5. پایبندی به اصول حرفه‌ای </strong>
                <br />
                من متعهد می‌شوم که به اصول حرفه‌ای کارگاه پایبند باشم. همچنین از
                برگزارکنندگان انتظار دارم که مهارت و دانش لازم برای ارائه کارگاه
                را داشته و آن را به‌روزرسانی کنند.
              </p>
              <p class="text-justified">
                <strong> 6. احترام و عدم قضاوت </strong>
                <br />
                من متعهد می‌شوم که در تمام تعاملات خود، به نظرات و تجربیات سایر
                شرکت‌کنندگان احترام بگذارم و از هرگونه قضاوت شخصی نسبت به دیگران
                خودداری نمایم.
              </p>
              <p class="text-justified">
                <strong> 7. تشویق به رشد شخصی و پذیرش مسئولیت </strong>
                <br />
                من متعهد می‌شوم که در مسیر رشد شخصی و خودآگاهی تلاش کنم و
                مسئولیت رفتارها و احساسات خود را در طول کارگاه بپذیرم و برای
                ایجاد تغییرات مثبت در زندگی خود اقدام نمایم.
              </p>
            </div> -->
          </div>
        </div>
      </template>
      <template #footer>
        <div class="w-100">
          <div class="float-start my-2">
            <input
              class="form-check-input form-check-input-danger animate-pulse-danger"
              type="checkbox"
              :checked="isRuleAccepted"
              @click="checkBoxClick($event)"
              id="flexCheckDefault"
            />
            <label
              class="form-check-label d-inline text-danger fw-bold pointer ct-animate-blink"
              for="flexCheckDefault"
            >
              شرایط فوق را می‌پذیرم
            </label>
          </div>
          <!-- <div class="float-end">
            <button
              class="btn btn-sm rounded btn-blueSite"
              @click="ruleConfirmationButtonClick"
              :disabled="!isRuleAccepted"
            >
              <i class="fi fi-check"></i>
              تایید
            </button>
          </div> -->
        </div>
      </template>
    </site-modal>

    <site-modal ID="informationModal" @closed="closeInformationModal">
      <template #header>
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-info-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            ></path>
            <path
              d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            ></path>
          </svg>
          راهنما
        </h6>
      </template>
      <template #body>
        <div>
          <p class="justified">
            <strong>راهنما 1)</strong>
            وضعیت ثبت نام جلسات:
            <br />
            <strong class="text-success">رنگ سبز:</strong>
            امکان ثبت‌نام وجود دارد.<br />
            <strong class="text-warning">رنگ زرد:</strong>
            ثبت‌نام شما قبلاً انجام شده است.<br />
            <strong class="text-danger">رنگ قرمز:</strong>
            امکان ثبت نام وجود ندارد.
          </p>
          <p class="justified">
            <strong>راهنما 2)</strong>

            مراجعین محترم توجه داشته باشید تمامی جلسات گروه درمانی و کارگاه‌ها
            <strong class="text-danger">«غیرقابل لغو و جابجایی»</strong> هستند،
            لطفا قبل از نهایی کردن ثبت نام خود، بررسی های لازم را به عمل آوردید.
          </p>
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="closeInformationModal"
          >
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
        </div>
      </template>
    </site-modal>

    <ol class="process-steps process-steps-primary text-muted m-1">
      <li
        class="process-step-item"
        :class="processStep == 0 ? 'active' : processStep > 0 ? 'complete' : ''"
      >
        <svg
          width="16px"
          height="16px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-filter-circle-fill ms-1"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
          ></path>
        </svg>
        عناوین
      </li>
      <li
        class="process-step-item"
        :class="processStep == 1 ? 'active' : processStep > 1 ? 'complete' : ''"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-check-lg"
          viewBox="0 0 16 16"
        >
          <path
            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
          ></path>
        </svg>
        انتخاب
      </li>

      <li
        class="process-step-item"
        :class="processStep == 2 ? 'active' : processStep > 2 ? 'complete' : ''"
      >
        <span>
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-circle-fill ms-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
            ></path>
          </svg>
          ثبت
        </span>
      </li>
    </ol>

    <div class="container border p-2 mb-2" id="mainDiv">
      <div v-if="processStep == 1">
        <div
          v-if="workshopSessions && workshopSessions.length > 0"
          class="alert mt-2 justified p-2"
        >
          <span
            class="spinner-grow spinner-grow-sm ms-1 text-danger"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="small text-danger">{{
            workshopSessions[0].paymentType == 2
              ? 'لطفا از میان تاریخ های زیر، سه جلسه را انتخاب نمائید.'
              : 'جهت ثبت نام، می بایست اولین جلسه قابل انتخاب را ثبت نام نمایید'
          }}</span>
        </div>
        <div
          class="row row-cols-2 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 g-2 my-2"
        >
          <div
            v-for="session in workshopSessions"
            :key="session.id"
            class="text-center"
          >
            <div
              class="card p-0 mb-1 ms-2 text-center cursor-pointer"
              @click="sessionCardClick(session)"
              :class="
                !session.isSelectable
                  ? ' unSelectable'
                  : session.isSelected
                  ? 'border-secondary shadow-lg '
                  : 'card-disable'
              "
              :title="
                !session.isSelectable
                  ? this.getSelectableStatus(session.selectableStatus)
                  : ''
              "
            >
              <div
                style="height: 40px"
                class="p-2"
                :class="getHeaderClass(session)"
              ></div>
              <div class="p-2">
                <div>{{ session.persianDayName }}</div>
                <div class="small">{{ session.sessionPersianDate }}</div>
                <div
                  style="unicode-bidi: bidi-override !important; direction: ltr"
                  class="gregorianDateClass"
                  v-if="$store.getters.isOverseas"
                >
                  {{ getGregorianDateOfSession(session.date) }}
                </div>
                <div class="smaller" dir="ltr">
                  {{ getTime(session.fromTime) }} -
                  {{ getTime(session.toTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="processStep == 2">
        <div class="alert mt-2 p-2">
          <span
            class="spinner-grow spinner-grow-sm ms-1 text-danger"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="text-danger"
            >جلسات گروه‌درمانی قابل لغو یا جابجایی نیستند</span
          >
        </div>

        <div class="row"></div>
        <div class="row g-1">
          <div
            v-for="(session, index) in getSelectedSessions()"
            :key="session.id"
          >
            <div class="card border-secondary text-dark" v-if="index == 0">
              <h5 class="card-header bg-lightsecondary">
                <div class="d-flex justify-content-between">
                  <div :class="isMobile ? 'fs-6' : ''">
                    {{
                      workshopData?.workshopGroupTherapyType == 1
                        ? 'سرپرست گروه:'
                        : 'مدرس:'
                    }}
                    <b :class="isMobile ? 'fs-6' : ''"
                      >{{ session.therapistName }}
                    </b>
                  </div>
                </div>
              </h5>
              <div class="card-body">
                <div class="row m-auto text-right">
                  <div :class="isMobile ? 'col-12' : 'col-6'">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      شیوه برگزاری:
                      <b>{{ session.sessionTypeTitle }}</b>
                    </h6>
                  </div>
                  <!-- <div :class="isMobile ? 'col-12' : 'col-md-6 col-12'">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      هزینه هر جلسه:
                      <b>
                        {{ thousandSeprator(session.price, ',', '.') }} ریال
                      </b>
                    </h6>
                  </div> -->
                  <!-- <div class="col-6">
                  <div class="col-md-6 col-12">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      تاریخ:
                      <b>{{ getPersianDate(session.date) }}</b>
                    </h6>
                  </div>

                  <h6 :class="isMobile ? 'fs-8' : ''">
                    ساعت:
                    <b dir="ltr"
                      >{{ getHourAndMinute(session.fromTime) }} -
                      {{ getHourAndMinute(session.toTime) }}</b
                    >
                  </h6>
                </div> -->

                  <!-- <div class="col-md-6 col-12" v-if="$store.getters.isOverseas">
                  <h6 :class="isMobile ? 'fs-8' : ''">
                    تاریخ(میلادی):
                    <b
                      style="
                        unicode-bidi: bidi-override !important;
                        direction: ltr;
                      "
                      class="gregorianDateClass"
                      >{{ getGregorianDateOfSession(session.date) }}</b
                    >
                  </h6>
                </div> -->
                  <!-- {{
                          thousandSeprator(
                            getSelectedSessions().length * session.price,
                            ',',
                            '.'
                          )
                        }}
                         -->
                  <div class="col-md-6 col-12">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      مبلغ کل:
                      <b>
                        {{
                          thousandSeprator(
                            getSelectedSessionTotalPrice(),
                            ',',
                            '.'
                          )
                        }}

                        ریال
                      </b>
                    </h6>
                  </div>

                  <div class="col-12" v-if="session.sessionTypeID == 1">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      آدرس: <b>{{ session.centerAddress }}</b>
                    </h6>
                  </div>
                  <div
                    :class="isMobile ? 'col-12' : 'col-6'"
                    v-if="session.sessionTypeID == 2"
                  >
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      (پلتفرم جلسه آنلاین: گوگل میت)
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(session, index) in getSelectedSessions()"
            :key="session.id"
            :class="isMobile ? 'col-6' : 'col-6 col-md-3 '"
          >
            <div class="card border-secondary h-100 shadow-xs">
              <div class="card-body p-2">
                <div class="">
                  <h6 :class="isMobile ? 'fs-8' : ''">
                    جلسه شماره:
                    <b>{{ index + 1 }}</b>
                  </h6>
                </div>
                <div>
                  <h6 :class="isMobile ? 'fs-8' : ''">
                    تاریخ:
                    <b>{{ getPersianDate(session.date) }}</b>
                  </h6>

                  <h6 :class="isMobile ? 'fs-8' : ''">
                    ساعت:
                    <b dir="ltr"
                      >{{ getHourAndMinute(session.fromTime) }} -
                      {{ getHourAndMinute(session.toTime) }}</b
                    >
                  </h6>

                  <h6 :class="isMobile ? 'fs-8' : ''">
                    هزینه:
                    <b>{{ thousandSeprator(session.price, ',', '.') }} </b> ریال
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 ms-3">
      <div class="text-start">
        <button
          class="btn btn-sm rounded btn-light-blue"
          type="button"
          @click="resetStartSessionSelection"
          v-if="
            !isMobile &&
            workshopSessionModalMode == 'readyForReservation' &&
            processStep == 1
          "
        >
          انتخاب مجدد
        </button>

        <button
          class="btn btn-sm float-start mb-2"
          @click="returnButtonClick"
          v-if="!(workshopData.limitationSessionType == 2 && processStep == 2)"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            ></path>
          </svg>
          <span> گام قبلی </span>
        </button>
        <button
          class="btn btn-sm rounded btn-blueSite float-end"
          type="button"
          @click="nextStepButtonClick"
          :disabled="getNextDisablity()"
          v-if="processStep < 2"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-calendar-range"
            viewBox="0 0 16 16"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              ></path>
            </svg>
          </svg>
          <span> گام بعدی </span>
        </button>

        <button
          data-v-22e1433f=""
          class="btn btn-sm btn-danger"
          v-if="processStep == 2"
          @click="createInvoiceButtonClick"
        >
          <svg
            data-v-22e1433f=""
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-receipt-cutoff"
            viewBox="0 0 16 16"
          >
            <path
              data-v-22e1433f=""
              d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
            ></path>
            <path
              data-v-22e1433f=""
              d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z"
            ></path>
          </svg>
          ثبت
        </button>

        <button
          class="btn btn-sm btn-warning"
          @click="openInformationModal"
          :class="isMobile ? 'px-1' : ''"
          v-if="processStep == 1"
        >
          <span> راهنما </span>
        </button>
      </div>
    </div>
    <div class="mb-3 ms-3" id="buttonDiv"></div>
  </div>
</template>

<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
// import HeaderDivider from '../../../../components/utility/headerDivider/HeaderDivider.vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { Modal } from 'bootstrap';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    LoadingSpinner,
    // HeaderDivider,
  },
  data() {
    return {
      isMobile: isMobile,
      workshopID: 0,
      ruleModal: new Object(),
      // goalsModal: new Object(),
      // detailsModal: new Object(),
      informationModal: new Object(),
      processStep: 1, // 1- detail 2- workshopSessions , 3-reservedSessions
      workshopSessions: [],
      isRuleAccepted: false,
      clientHasOpenWorkshopInvoice: false,
      workshopSessionModalMode: 'chooseStartSession',
      workshopData: {
        id: 0,
        title: '',
        therapistName: '',
        workshopGroupSubject: '',
        workshopGroupAudienceType: '',
        workshopGroupTherapyTypeTitle: '',
        workshopGroupTherapyType: 1,
        maxParticipantCount: 0,
        minParticipantCount: 0,
        participantType: '',
        price: 0,
        sessionCount: 0,
        startDate: null,
        description: '',
        paymentType: '',
        limitationSessionType: '',
        sessionType: '',
        specializationType: '',
        goals: '',
      },

      sessionReservationViewModel: {
        workshopGroupTherapyID: null,
        workshopGroupTherapySessionIDs: [],
        personID: null,
        sendPaymentRequest: false,
        usingWalletBalance: false,
      },
    };
  },
  methods: {
    getTime(time) {
      if (!time) {
        return '';
      }
      return time.toString().substr(0, 5);
    },
    getHeaderClass(session) {
      if (session.isSelectable && session.isSelected) {
        return 'bg-success-selected';
      }
      if (session.isSelectable && !session.isSelected) {
        return 'bg-success-deselect';
      }

      if (!session.isSelectable) {
        if (session.selectableStatus == 3) {
          return 'bg-warning-deselect unSelectable';
        }
        if (session.selectableStatus == 4) {
          return 'bg-danger-deselect unSelectable';
        }
      }
      return '';
    },
    async getWorkshopData() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(
          `/CLC/WorkshopGroupTherapy/GetWorkshopGroupTherapyDTOForSite/${that.workshopID}`
        )
        .then((response) => {
          if (response.data) {
            that.workshopData = response.data;
            if (that.workshopData.limitationSessionType == 2) {
              that.processStep = 2;
            }
          }
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getThousand(amount) {
      /* eslint-disable */
      return thousandSeprator(amount);
    },
    returnButtonClick() {
      if (this.processStep == 1) {
        this.$router.push({
          name: 'workshopTab',
          params: {
            id: this.$store.getters.userPersonID,
            type: this.workshopData.workshopGroupTherapyType,
          },
        });
        return;
      }

      this.processStep -= 1;
    },
    async nextStepButtonClick() {
      if (
        this.workshopData.workshopGroupTherapyType == 1 &&
        this.processStep == 1 &&
        this.isRuleAccepted == false
      ) {
        this.ruleModal.show();
        return;
      }
      if (this.processStep == 2 && this.getSelectedSessions().length == 0) {
        this.$refs.notification.show({
          type: 'error',
          title: `جلسات مورد نظر را انتخاب نمایید`,
        });
        return;
      }

      if (this.processStep < 3) this.processStep += 1;
    },
    async getWorkshopSessions() {
      let that = this;

      await axios
        .get(
          `/CLC/WorkshopGroupTherapy/GetWorkshopSessionsForReserveForSite?id=${that.workshopID}&&personID=${this.$store.getters.userPersonID}`
        )
        .then((response) => {
          if (response.data && response.data.length > 0) {
            that.workshopSessions = response.data.filter(
              (f) => f.selectableStatus != 1
            );

            if (that.workshopData.limitationSessionType == 2) {
              that.workshopSessions.forEach((f) => (f.isSelected = true));
            }
          }
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `دریافت لیست جلسات با خطا مواجه گردید`,
          });
        });
    },
    getTime(time) {
      if (!time) {
        return '';
      }
      return time.toString().substr(0, 5);
    },
    getSelectableStatus(selectableStatus) {
      return '';
      switch (selectableStatus) {
        case 1:
          return 'زمان جلسه گذشته';
        case 2:
          return 'ظرفیت تکمیل';
        case 3:
          return 'رزرو / ثبت شده';
        case 4:
          return 'لغو شده';
        default:
          return '';
      }
    },
    sessionCardClick(session) {
      if (session.isSelectable == false) {
        this.showErrorUnselectable(session);
        return;
      }
      if (
        session.paymentType == 1 &&
        this.workshopSessionModalMode == 'readyForReservation'
      ) {
        this.resetStartSessionSelection();
        return;
      }

      if (session.paymentType == 1) {
        var prevSessions = this.workshopSessions.filter(
          (f) => f.sessionNumber < session.sessionNumber && f.isSelectable
        );
        if (prevSessions && prevSessions.length > 0) {
          this.$refs.notification.show({
            type: 'error',
            title: `با توجه نوع تسویه این گروه درمانی (کارگاه) شما می بایست اولین جلسه موجود را انتخاب نمایید`,
          });
          return;
        }
      }
      let selectionCount = this.getSelectedSessions().length;
      let selectableCount = this.getSelectableSessions().length;

      if (session.paymentType == 2) {
        if (session.isSelected == true) {
          session.isSelected = false;
          selectionCount = this.getSelectedSessions().length;
        } else if (selectionCount < 3) {
          session.isSelected = true;
          selectionCount++;
        }

        if (selectionCount == 3 || selectableCount == selectionCount) {
          this.workshopSessionModalMode = 'readyForReservation';
          if (isMobile) {
            location.href = '#buttonDiv';
          }
        } else {
          this.workshopSessionModalMode = 'chooseStartSession';
        }
      }

      //this.startSessionForReservation = session;

      if (session.paymentType == 1) {
        this.workshopSessions
          .filter(
            (f) => f.sessionNumber >= session.sessionNumber && f.isSelectable
          )
          .forEach((item) => {
            item.isSelected = true;
            if (session.paymentType == 1) item.isSelected = true;
          });
        this.workshopSessionModalMode = 'readyForReservation';
        if (isMobile) {
          location.href = '#buttonDiv';
        }
      }
    },

    showErrorUnselectable(session) {
      if (!session.isSelectable) {
        if (session.selectableStatus == 3) {
          this.$refs.notification.show({
            type: 'warning',
            title: `این جلسه قبلا توسط شما ثبت شده است`,
          });
        }
        if (session.selectableStatus == 4) {
          this.$refs.notification.show({
            type: 'error',
            title: `این جلسه لغو شده و انجام ثبت نام در این تاریخ امکان پذیر نمی باشد`,
          });
        }
      }
    },
    resetStartSessionSelection() {
      this.workshopSessionModalMode = 'chooseStartSession';
      this.workshopSessions.forEach((item) => {
        item.isSelected = false;
      });
    },
    getSelectedSessions() {
      let sessions = this.workshopSessions.filter((f) => f.isSelected == true);
      return sessions ?? [];
    },
    getSelectableSessions() {
      let sessions = this.workshopSessions.filter(
        (f) => f.isSelectable == true
      );
      return sessions ?? [];
    },
    getNextDisablity() {
      if (
        this.processStep == 1 &&
        (this.getSelectedSessions().length == 0 ||
          this.workshopSessionModalMode != 'readyForReservation')
      ) {
        return true;
      }

      return false;
    },

    closedRuleModal() {
      this.ruleModal.hide();
    },

    checkBoxClick(e) {
      this.isRuleAccepted = e.target.checked;
      this.processStep += 1;
      this.closedRuleModal();
    },
    async getRuleAcceptance() {
      let that = this;
      await axios
        .get(
          `/CLC/WorkshopGroupTherapy/CheckLegalRuleAcceptanceForSite?id=${that.workshopID}&&personID=${this.$store.getters.userPersonID}`
        )
        .then((response) => {
          that.isRuleAccepted = response.data;
        })
        .catch(() => {
          that.isRuleAccepted = false;
        });
    },
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    async createInvoiceButtonClick() {
      let that = this;
      that.sessionReservationViewModel.workshopGroupTherapyID = this.workshopID;
      that.sessionReservationViewModel.personID =
        that.$store.getters.userPersonID;
      that
        .getSelectedSessions()
        .forEach((f) =>
          that.sessionReservationViewModel.workshopGroupTherapySessionIDs.push(
            f.id
          )
        );
      that.$refs.spinner.show();
      await axios
        .post(
          `/CLC/WorkshopGroupSession/ReserveSessionsForSite`,
          that.sessionReservationViewModel
        )
        .then((response) => {
          if (response?.data?.success == false) {
            response.data.errors.forEach((element) => {
              this.$refs.notification.show({
                type: 'error',
                title: element.errorMessage,
              });
            });
            return;
          }

          if (response?.data?.success == true) {
            this.$refs.notification.show({
              type: 'success',
              title: 'عملیات رزرو جلسات با موفقیت انجام شد',
            });
            that.$store.dispatch('setClientWorkshopSearchModel', null);
            that.clientHasOpenWorkshopInvoice = true;
            that.$router.push({
              name: 'workshopInvoice',
              id: this.$store.getters.userPersonID,
            });
          }
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات رزرو جلسه با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          that.$refs.spinner?.hide();
        });
    },
    compareDateWithToday(date) {
      return new Date() > new Date(date);
    },

    closeInformationModal() {
      this.informationModal.hide();
    },
    openInformationModal() {
      this.informationModal.show();
    },
    getSelectedSessionTotalPrice() {
      let sessions = this.getSelectedSessions();
      let sum = 0;
      sessions.forEach((f) => (sum += f.price));
      return sum;
    },
  },
  async beforeMount() {
    if (!this.$router.currentRoute.value.path.includes('workshopInvoice')) {
      let that = this;
      await axios
        .get(
          `/FN/InvoiceHeader/CheckClientHasWorkshopInvoice?personID=${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          if (response.data) {
            that.clientHasOpenWorkshopInvoice = true;
            that.$router.push({
              name: 'workshopInvoice',
              id: this.$store.getters.userPersonID,
            });
          }
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات بررسی صورت وضعیت با خطا مواجه گردید.`,
          });
        });
    }
  },

  async mounted() {
    const route = useRoute();
    let that = this;
    that.workshopID = route.params.id;
    this.ruleModal = new Modal(document.getElementById('ruleModal'), {
      keyboard: false,
    });
    // this.goalsModal = new Modal(document.getElementById('goalsModal'), {
    //   keyboard: false,
    // });
    // this.detailsModal = new Modal(document.getElementById('detailsModal'), {
    //   keyboard: false,
    // });
    this.informationModal = new Modal(
      document.getElementById('informationModal'),
      {
        keyboard: false,
      }
    );

    await that.getWorkshopData();
    await that.getRuleAcceptance();
    await that.getWorkshopSessions();
    if (isMobile) {
      location.href = '#';
      location.href = '#sessionDiv';
    }
  },
};
</script>

<style scoped>
.workshop-image {
  height: 300px !important;
}
.process-step-item {
  border-bottom: 3px solid #cdcdcd;
  color: #cdcdcd;
}
.process-step-item::after {
  border-color: #cdcdcd;
}
.process-steps-primary > .active .process-steps-primary > .complete {
  border-color: #4c5e74;
}
.process-step-item:before {
  border-color: #cdcdcd;
}
.process-steps-primary > .active,
.process-steps-primary > .complete {
  border-bottom-color: #4c5e74;
}
.process-steps-primary > .complete {
  color: #9facbd !important;
}
.process-steps-primary > .active {
  color: #4c5e74;
}
.process-steps-primary > .active:before,
.process-steps-primary > .complete:before {
  border-color: #4c5e74;
}
.process-steps-primary > .active:before,
.process-steps-primary > .complete:before {
  background-color: #4c5e74;
}
.unSelectable {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(148, 50, 50, 0.1),
    rgba(132, 129, 165, 0.9) 0.5px,
    transparent 1px,
    transparent 15px
  );
  color: rgb(128, 125, 125);
}
.bg-lighGreen {
  background-color: #a1d6b2 !important;
}
.bg-lightRed {
  background-color: #d9abab !important;
}
.headerResult {
  background-color: #4c5e74;
  color: white;
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
}
.ct-animate-blink {
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
}

.bg-success-deselect {
  background-color: rgba(109, 187, 48, 0.3) !important;
}
.bg-success-selected {
  background-color: rgba(109, 187, 48, 0.8) !important;
}

.bg-warning-deselect {
  background-color: #fdedc0 !important;
}
.bg-danger-deselect {
  background-color: #feeef0 !important;
}

@keyframes blink {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
</style>
